import '@/modules/common/directives'
import router from './router'
import store from './store'
import filters from '@/modules/common/filters'
import hooks from '@/hooks'
import 'bootstrap'
import BootstrapVue from 'bootstrap-vue'
import 'jquery'
import App from '@/modules/app/components/app.vue'
import validationsInit from '@/modules/common/validation'
import notificationService from '@/modules/common/services/notificationService'
import firebase from '@/firebase'
import Vue from 'vue'
import { auth } from 'firebase/app'
import urlCleanHook from '@/hooks/urlCleanHook'
import VueClipboard from 'vue-clipboard2'

// first step, clean invalid URL, e.g. facebook fbclid etc. Continue only if url was not cleared
if (!urlCleanHook()) {
  let app: Vue

  firebase.init()

  validationsInit()

  filters()

  // register hooks
  hooks(router)

  // init bootstrap-vue
  Vue.use(BootstrapVue)

  Vue.config.productionTip = false

  auth().onAuthStateChanged(function () {
    if (!app) {
      app = new Vue({
        router,
        store,
        render: h => h(App)
      }).$mount('#app')
    }
  })

  notificationService.init()

  Vue.use(VueClipboard)
}
